import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { CheckIntegration } from "./check-integration";

/** Props Interface */
interface AutoIntegrationModalProps extends ModalProps {
	onComplete: () => Promise<unknown>;
	integrationType: "webfleet";
}

export function AutoIntegrationModal({
	isOpen,
	onClose,
	onComplete,
	integrationType,
}: AutoIntegrationModalProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={t(`integrations.${integrationType}_auto_integration`)}
			width="95vw"
		>
			<Modal.Body>
				<CheckIntegration
					integrationType={integrationType}
					onComplete={onComplete}
				/>
			</Modal.Body>
		</Modal>
	);
}
